
const numberOnly = {
  bind(el, binding, vnode) {
    el.type = 'number';
  
    el.addEventListener('keypress', (e) => {
      const charCode = (e.which) ? e.which : e.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        e.preventDefault();
      } else {
        return true;
      }
    });
  },
};
export default numberOnly;
